import RestrictedAccess from '@/components/Modal/RestrictedAccess';
import { userAppContext } from '@/context/Context';
import { buildToolAccessContext, canUseTool, getToolAccess } from '@/components/Tools/toolAccess';

export default function Installation() {
  const { user, isAuthenticated } = userAppContext();
  const accessCtx = buildToolAccessContext(isAuthenticated, user?.['cognito:groups']);
  const access = getToolAccess('cytoscape', accessCtx);
  const isRestricted = !canUseTool('cytoscape', accessCtx);

  return (
    <div>
      <p>The DISGENET Cytoscape App is available from the Cytoscape App Store.</p>
      <RestrictedAccess
        isRestricted={isRestricted}
        restrictedMessage={
          <h6>
            {access.reason ?? 'Cytoscape access is not included in your current plan.'}{' '}
            <a href={access.upgradeHref} style={{ color: '#D02591' }}>
              {access.status === 'login' ? 'Sign in' : 'See plans'}
            </a>
            .
          </h6>
        }
      >
        <p>
          Install from{' '}
          <a href="https://apps.cytoscape.org/apps/disgenetapp" target="_blank" rel="noreferrer">
            https://apps.cytoscape.org/apps/disgenetapp
          </a>
        </p>
      </RestrictedAccess>
    </div>
  );
}
